export default function CaretUp({fill = 'white'}) {
  return (
    <svg style={{padding: "4px"}} width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.6312 2.58625L9.4522 6.40725C9.8662 6.82125 10.5382 6.82125 10.9522 6.40725C11.3662 5.99325 11.3662 5.32125 10.9522 4.90725L6.3382 0.29325C5.9472 -0.09775 5.3142 -0.09775 4.9242 0.29325L0.310195 4.90725C-0.103805 5.32125 -0.103805 5.99325 0.310195 6.40725C0.724195 6.82125 1.3962 6.82125 1.81019 6.40725L5.6312 2.58625Z" fill="white"/>
    </svg>
  )
}


